<template>
	<footer>
		<div v-if="type == 3">
			<a style="margin: 0 auto;"
            id="v-step-1"
            class="btn btn-primary"
            href="javascript:;"
            @click="openOffer"
          >查看更多热卖商品</a>
		</div>
        <div v-else>
          <div v-if="type == 1" id="v-step-0">
          	<span >
          		已选 可供货商品 <span>{{arr.length}}</span> 件
	            <a
	              class=" tx-primary"
	              href="javascript:;"
	              title="清空重选"
	              @click="clearCanSupplyId"
	            >清空</a>
          	</span>
          </div>
          <div v-else id="v1-step-1">
          	<span>
            	如果全部由您供货，30天将额外为您带来<span>￥{{parseFloat(sum_price).toFixed(2)}}</span>元的销售额
            </span>
          </div>
          <a
            :id="type == 1?'v-step-1':'v1-step-2'"
            class="btn btn-primary"
            href="javascript:;"
            @click="openOffer"
          >{{type == 1?'查看待报价商品清单':'提交供货信息'}}</a>
        </div>
    </footer>
</template>

<script>
export default {
props:["type","arr","sum_price"],
methods: {
	openOffer(){
		if(this.type ==1){
			this.openPageOffer();
//			this.$router.push({ path: 'page-offer' })
		}else if(this.type ==2){
			this.openRegModal();
		}else if(this.type ==3){
			this.$router.push({ name: 'page' })
		}
	},
	clearCanSupplyId(){
		this.$emit("clearCanSupplyId");
	},
	openPageOffer(){
		this.$emit("openPageOffer")
	},
	openRegModal(type){
		this.$emit("openRegModal",this.type);
	},
  }
};
</script>

<style lang="less" scoped>
@import "./../assets/style/config.less";
footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 1rem;
  background-color: #fff;
  border-bottom: 0.0625rem #e6e6e6 solid;
  min-width: 39.375rem;
  padding: 15px;
  border: 1px solid @primary;
  background-color: @b-c-gray;
  box-shadow: 1px 0 12px #ccc;
  > div {
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: @black-1;
    > div {
      font-size: 14px;
      > span {
        >span{
        	color: @primary;
        	font-weight: bold;
        	font-size: 16px;
        }
      }
    }
  }
}
</style>